import { BadgeDomain } from "../../Abstractions/BadgeDomain";
import { SemiTrailerType, SemiTrailerTypeColor } from "../../../domain/VehicleType";

export function SemiTrailerTypeBadge({ type, size }) {
  return (
    <BadgeDomain size={size} bg={SemiTrailerTypeColor[type]}>
      {SemiTrailerType[type]}
    </BadgeDomain>
  );
}